import { createStyles, css } from 'antd-style';
import { type FC, useEffect, useMemo, useRef, useState } from 'react';

const useStyles = createStyles(() => {
  return {
    charging: css`
      @keyframes charging {
        0% {
          opacity: 0.5;
        }
        100% {
          opacity: 1;
        }
      }
      animation: charging 0.6s linear infinite alternate;
    `,
  };
});

interface DynamicBatteryProps {
  level: number;
  direction?: 'horizontal' | 'vertical';
  size?: number;
  isCharging?: boolean;
  showNumber?: boolean;
  style?: React.CSSProperties;
}

const DynamicBattery: FC<DynamicBatteryProps> = ({
  level = 0,
  direction = 'horizontal',
  size = 64,
  isCharging = false,
  showNumber = false,
  style = {},
}) => {
  const { styles } = useStyles();
  const [animateLevel, setAnimateLevel] = useState(level);

  const barHeight = useMemo(() => {
    return (animateLevel / 100) * 45;
  }, [animateLevel]);
  const barY = useMemo(() => {
    return 57 - barHeight;
  }, [barHeight]);

  // const fillRef = useRef<SVGRectElement | null>(null);

  // useEffect(() => {
  //   if (fillRef.current) {
  //     const newHeight = (animateLevel / 100) * 45;
  //     const newY = 57 - newHeight;
  //     fillRef.current.setAttribute('height', `${newHeight}`);
  //     fillRef.current.setAttribute('y', `${newY}`);
  //   }
  // }, [animateLevel]);

  useEffect(() => {
    setAnimateLevel(level);
  }, [level]);

  useEffect(() => {
    let chargingTimer: NodeJS.Timeout;
    if (isCharging) {
      chargingTimer = setInterval(() => {
        setAnimateLevel((lv) => {
          if (lv < 100) {
            return lv + 1;
          }
          return level;
        });
      }, 60);
    }
    return () => {
      if (chargingTimer) clearInterval(chargingTimer);
    };
  }, [isCharging]);

  const fillColor = useMemo(() => {
    return animateLevel <= 20
      ? 'var(--ant-red-6)'
      : animateLevel <= 30
        ? 'var(--ant-gold-6)'
        : 'var(--ant-green-6)';
  }, [animateLevel]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 64"
      width={size * 0.625}
      height={size}
      style={{
        transform: direction === 'vertical' ? 'none' : 'rotate(90deg)',
        verticalAlign: 'middle',
        ...style,
      }}
      className={isCharging ? styles.charging : ''}
      role="graphics-symbol"
    >
      <rect fill={fillColor} x="13" y="0" width="14" height="4"></rect>
      <rect
        stroke={fillColor}
        fill="none"
        x="2"
        y="7"
        width="36"
        height="55"
        rx="4"
        ry="4"
        strokeWidth="4"
      ></rect>
      <rect
        fill={fillColor}
        // ref={fillRef}
        x="7"
        y={barY}
        width="26"
        height={barHeight}
      ></rect>
      {showNumber && (
        <text
          x="45%"
          y="54%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="27"
          fill="black"
          style={{
            transform: direction === 'vertical' ? 'none' : 'rotate(-90deg)',
            transformOrigin: 'center center',
          }}
        >
          {Math.round(level)}
        </text>
      )}
    </svg>
  );
};

export default DynamicBattery;
